<template>
  <ACard id="account-status">
    <template #title>
      <span class="acc-status__title">
        <i class="material-icons-round acc-status__title-icon">verified_user</i>
        계정 상태 관리
      </span>
    </template>
    <template #sub>
      {{ isEmployee && !allowDelete
        ? '직원 계정은 활성화/비활성화만 가능합니다.'
        : '계정을 비활성화하거나 삭제할 수 있습니다. 삭제된 계정은 복구할 수 없습니다.' }}
    </template>

    <div class="acc-status">
      <div class="acc-status__current">
        <span class="acc-status__label">현재 상태</span>
        <APill :kind="statusPillKind" dot>{{ statusText }}</APill>
      </div>

      <div class="acc-status__actions">
        <ABtn
          v-if="currentStatus === 'N'"
          kind="primary"
          icon="check_circle"
          @click="$emit('activate-account')"
        >활성화</ABtn>
        <ABtn
          v-if="currentStatus === 'Y'"
          kind="danger"
          icon="block"
          @click="$emit('deactivate-account')"
        >비활성화</ABtn>
        <ABtn
          v-if="(!isEmployee || allowDelete) && currentStatus !== 'D'"
          kind="danger-fill"
          icon="delete_forever"
          @click="$emit('delete-account')"
        >계정 삭제</ABtn>
      </div>

      <div v-if="isEmployee && !allowDelete" class="acc-status__notice">
        <i class="material-icons-round">info</i>
        <span>직원 계정은 보안상의 이유로 탈퇴할 수 없습니다. 계정 비활성화만 가능합니다.</span>
      </div>
    </div>
  </ACard>
</template>

<script>
import ACard from "@/components/Pineapple/ACard.vue";
import APill from "@/components/Pineapple/APill.vue";
import ABtn from "@/components/Pineapple/ABtn.vue";

export default {
  name: "AccountStatusCard",
  components: { ACard, APill, ABtn },
  props: {
    currentStatus: {
      type: String,
      default: "Y",
      validator: (v) => ["Y", "N", "D"].includes(v),
    },
    isEmployee: { type: Boolean, default: false },
    allowDelete: { type: Boolean, default: false },
  },
  emits: ["activate-account", "deactivate-account", "delete-account"],
  computed: {
    statusText() {
      return { Y: "활성", N: "비활성", D: "탈퇴" }[this.currentStatus] || "알 수 없음";
    },
    statusPillKind() {
      return { Y: "ok", N: "warn", D: "err" }[this.currentStatus] || "default";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.acc-status {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 800;
    color: $p-ink;
  }

  &__title-icon {
    color: $p-point-deep;
    font-size: 16px !important;
  }

  &__current {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__label {
    font-size: 12px;
    color: $p-ink-mid;
    font-weight: 700;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__notice {
    display: flex;
    gap: 8px;
    padding: 12px 14px;
    background: $p-info-soft;
    border-left: 3px solid $p-info;
    border-radius: $p-radius-md;
    color: $p-ink2;
    font-size: 12px;
    line-height: 1.5;

    > i {
      color: $p-info;
      font-size: 16px;
      flex-shrink: 0;
    }
  }
}
</style>
